import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  generateQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/quiz-generator`,
  },
  generateSlide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/generate-slide`,
  },
  requestMoreQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/request-more-quiz`,
  },
  getExamples: {
    method: 'GET',
    url: `${configs.baseUrl}/api/openai/get-examples`,
  },
  generateTemplateDescription: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/generate-template-description`,
  },
  sendFeedbackOnDocumentQuizzes: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/document-quizzes/feedback`,
  },
  sendFeedbackOnSlidesGeneratorResult: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/generate-slide/feedback`,
  },
  groupOpenEndedAnswers: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/group-open-ended/{slideId}`,
  },
  stressTestOpenEndedAnswers: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/group-open-ended-stress-test/{slideId}`,
  },
  createMultipleAnswersWordCloud: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/create-answers-word-cloud/{slideId}`,
  },

  // INITIAL-CONTENT
  generateInitialContent: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/chat`,
  },

  generateInitialContentV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/presentation:create`,
  },

  generateInitialContentV3: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/chat/v2`,
  },

  improveSlideContent: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/slide:improve-content`,
  },
  improveTextBlock: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/canvas-block:improve`,
  },

  getSlideOptionAutocomplete: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/question:generate-answers`,
  },

  generateOptions: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/slide:generate-quiz-options`,
  },

  generateSlideOptions: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/slide:generate-slide-options`,
  },

  fetchMisspellList: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/presentation:check-spelling`,
  },

  dismissMisspell: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/presentation:dismiss-misspelled`,
  },
  dismissBatchMisspell: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/presentation:batch-dismiss-misspelled`,
  },

  trackAIAction: {
    method: 'POST',
    url: `${configs.baseUrl}/api/ai-action/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// AI SLIDES GENERATOR
const generateQuiz = async (params) => {
  const res = await resource.generateQuiz(params)
  return res.body
}

const generateSlide = async (params) => {
  const res = await resource.generateSlide(params)
  return res.body
}

const getExamples = async () => {
  const res = await resource.getExamples()
  return res.body
}

// DOC TO QUIZ
const requestMoreQuiz = async (params) => {
  const res = await resource.requestMoreQuiz(params)
  return res.body
}

const sendFeedbackOnDocumentQuizzes = async (params) => {
  const res = await resource.sendFeedbackOnDocumentQuizzes(params)
  return res.body
}

// TEMPLATE DESCRIPTION
const generateTemplateDescription = async (params) => {
  const res = await resource.generateTemplateDescription(params)
  return res.body
}

// GROUP OPEN ENDED ANSWERS
const groupOpenEndedAnswers = async (slideId, params) => {
  await resource.groupOpenEndedAnswers({ slideId }, params)
}

const stressTestOpenEndedAnswers = async (payload) => {
  const { slideId } = payload
  await resource.stressTestOpenEndedAnswers({ slideId }, payload)
}

// WORD CLOUD
const createMultipleAnswersWordCloud = async (payload) => {
  const { slideId } = payload
  await resource.createMultipleAnswersWordCloud({ slideId }, payload)
}

const sendFeedbackOnSlidesGeneratorResult = async (params) => {
  const res = await resource.sendFeedbackOnSlidesGeneratorResult(params)
  return res.body
}

// INITIAL-CONTENT
const generateInitialContent = async (params) => {
  const res = await resource.generateInitialContent(params)
  return res.body
}

const generateInitialContentV2 = async (params) => {
  const res = await resource.generateInitialContentV2(params)
  return res.body
}

const generateInitialContentV3 = async (params) => {
  const res = await resource.generateInitialContentV3(params)
  return res.body
}

const improveSlideContent = (params) => {
  return resource.improveSlideContent(params)
}
const improveTextBlock = (params) => {
  return resource.improveTextBlock(params)
}

const getSlideOptionAutocomplete = async (payload) => {
  const res = await resource.getSlideOptionAutocomplete(payload)
  return res.body
}
const generateSlideOptions = async (payload) => {
  const res = await resource.generateSlideOptions(payload)
  return res.body
}

const generateOptions = async (payload) => {
  const res = await resource.generateOptions(payload)
  return res.body
}

const fetchMisspellList = async ({ presentationId }) => {
  const res = await resource.fetchMisspellList({ presentationId })
  return res.body
}

const dismissMisspell = async ({ presentationId, misspell }) => {
  const res = await resource.dismissMisspell({ presentationId, misspell })
  return res.body
}
const dismissBatchMisspell = async ({ presentationId, misspellings }) => {
  const res = await resource.dismissBatchMisspell({ presentationId, misspellings })
  return res.body
}

const trackAIAction = async ({
  objectId, objectType, actionType, actionDetail,
}) => {
  await resource.trackAIAction({
    objectId, objectType, actionType, actionDetail,
  })
}

export default {
  initResource,

  // AI SLIDES GENERATOR
  generateQuiz,
  generateSlide,
  getExamples,

  // DOC TO QUIZ
  requestMoreQuiz,
  sendFeedbackOnDocumentQuizzes,
  sendFeedbackOnSlidesGeneratorResult,

  // TEMPLATE DESCRIPTION
  generateTemplateDescription,

  // GROUP OPEN ENDED ANSWERS
  groupOpenEndedAnswers,
  stressTestOpenEndedAnswers,
  createMultipleAnswersWordCloud,

  // INITIAL-CONTENT
  generateInitialContent,
  generateInitialContentV2,
  generateInitialContentV3,

  improveSlideContent,
  improveTextBlock,
  getSlideOptionAutocomplete,
  generateOptions,
  generateSlideOptions,
  fetchMisspellList,
  dismissMisspell,
  dismissBatchMisspell,
  trackAIAction,
}
